import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import Notification from "../notification/Notification";
import { TextField } from "@material-ui/core";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { useTranslation } from "react-i18next";

import { StyledInvoiceWrapper } from "../invoiceDialog/styledInvoice";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const CreateCurrencyButton = ({ type, fetchCurrency }) => {
  const { t } = useTranslation("currenciesPage");

  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const defaultData = {
    "asset": null,
    "type": type.toUpperCase(),
    "name" : null
  };

  const [submitData, setSubmitData] = useState(defaultData);

  const createInvoice = async () => {
    setDisabled(true);

    let data = {
      asset: submitData.asset,
      type: submitData.type,
      name: submitData.name
    };

    axios.post("/api/currencies", data, userAuthenticationConfig()).then(response => {
      if (response.status === 201) {
        fetchCurrency();
        setNotification({ ...notification, visible: true, type: "success", message: t("currency.createForm.success") });
        handleClose();
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setSubmitData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledInvoiceWrapper>
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("currency.createForm.create")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("currency.createForm.addCurrency")}
            </StyledDialogHead>
            <StyledDialogContent>
              <TextField
                id="asset"
                label={t("currency.createForm.currencyAsset")}
                value={submitData.asset}
                onChange={(data) => setSubmitData({ ...submitData, "asset": data.target.value })}
              />
              <TextField
                id="name"
                label={t("currency.createForm.name")}
                value={submitData.name}
                onChange={(data) => setSubmitData({ ...submitData, "name": data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("currency.createForm.cancelBtn")}
              </DefaultButton>
              <DefaultButton
                color="success"
                onClick={createInvoice}
                disabled={disabled}
              >
                {t("currency.createForm.createBtn")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledInvoiceWrapper>
    </>
  );
};

export default CreateCurrencyButton;